import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from './store'

interface MainInfoTutorReturn {
  refHref: ComputedRef<string>
  refLabel: ComputedRef<string>
}

export const useMainInfoTutor = (): MainInfoTutorReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refHref = computed<string>(() => {
    return useAdminRoutes('admin.tutor.show', { tutor_id: tutorKanbanStore.getTutor?.id || 0 }) || ''
  })

  const refLabel = computed<string>(() => {
    const tutor = tutorKanbanStore.getTutor
    if (!tutor) return ''
    return `${tutor.full_name} #${tutor.id}`
  })

  return {
    refHref,
    refLabel,
  }
}
